// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-shypcx-jxShypcx-index-main_right_content-2IrxF","table":"components-tjcx-shypcx-jxShypcx-index-table-2rV9y"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/shypcx/jxShypcx/index.css
// module id = 2314
// module chunks = 0